export default "__VITE_ASSET__D$2qHAeH__"